<div class="middle_column_grid">
    <div class="middle_column">
        <router-outlet></router-outlet>
    </div>
</div>